export class RetiroEfectivo {
    public motivoRetiro: string;
    public montoRetiro: number;
    public correoElectronico: string;
    public contrasenia: string;
    public DOCUMENT_ID : number;

    STATUS_DATE?: Date;
    organizationId?: number;
}


// WEBPACK FOOTER //
// ./src/app/models/retiro.ts